import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import Format from '../../../Services/Format';
import { SellerTotal } from '../useSalesAnalytics';
import * as S from './styles';

/**
 * Paleta categórica do painel. Sete matizes distintas cobrem a equipe típica;
 * acima disso as cores se repetem, mas a legenda continua identificando cada
 * vendedor pelo nome.
 */
const COLORS = [
  '#4F46E5',
  '#F97316',
  '#DC2626',
  '#0EA5E9',
  '#16A34A',
  '#9333EA',
  '#9CA3AF',
];

function SellerTooltip({ active, payload }: any) {
  if (!active || !payload?.length) return null;
  const point = payload[0]?.payload;

  return (
    <S.TooltipCard>
      <span className="name">{point?.name}</span>
      <span>{Format.formatCurrencyBr(point?.total)}</span>
      <span>
        {point?.orders} pedido{Number(point?.orders) === 1 ? '' : 's'}
      </span>
    </S.TooltipCard>
  );
}

export function SalesBySeller({
  sellers,
  isFetching,
  errorMessage,
}: {
  sellers: SellerTotal[];
  isFetching?: boolean;
  errorMessage?: string | null;
}) {
  const total = sellers.reduce((acc, seller) => acc + seller.total, 0);

  return (
    <S.Container>
      <h3>Vendas por Vendedor</h3>

      {sellers.length > 0 && total > 0 ? (
        <div className="chart-area">
          <div className="chart">
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie
                  data={sellers}
                  dataKey="total"
                  nameKey="name"
                  innerRadius="58%"
                  outerRadius="88%"
                  paddingAngle={2}
                  stroke="#fff"
                  strokeWidth={2}
                >
                  {sellers.map((seller, index) => (
                    <Cell key={seller.id} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<SellerTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="legend">
            {sellers.map((seller, index) => {
              const share = total > 0 ? (seller.total / total) * 100 : 0;

              return (
                <div key={seller.id} className="legend-item">
                  <span
                    className="dot"
                    style={{ background: COLORS[index % COLORS.length] }}
                  />
                  <span className="name" title={seller.name}>
                    {seller.name}
                  </span>
                  <span className="value">{share.toFixed(1)}%</span>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className={errorMessage ? 'not-data error' : 'not-data'}>
          {errorMessage
            ? `Não foi possível carregar as vendas: ${errorMessage}`
            : isFetching
            ? 'Carregando vendas do período…'
            : 'Nenhuma venda no período selecionado.'}
        </div>
      )}
    </S.Container>
  );
}
